import { Box, Flex, Text } from '@pinchenterprisesnpm/friday-ui'
import styled from 'styled-components'

export const SmartPayContainer = styled(Box)<{
  backgroundColor?: string
  hasError?: boolean
}>`
  background: ${({ backgroundColor }) => backgroundColor};
  border-radius: ${({ theme: { mp } }) => mp.sm};
  ${({ hasError, theme: { palette } }) =>
    hasError &&
    `
      border: 1px solid ${palette.danger};
    `}
`

export const RecommendedPayContainer = styled(Flex)`
  background: ${({ theme: { palette } }) => palette.white};
  height: 42px;
  border-radius: 4px;
  border: 1px solid ${({ theme: { palette } }) => palette.border};
`

export const InputWrapper = styled(Box)`
  position: relative;
  width: fit-content;
`

export const RecommendedPillContainer = styled(Flex)`
  background: ${({ theme: { palette } }) => palette.primary};
  border-radius: 14px;
  width: fit-content;
  height: fit-content;

  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
`

export const PricingWrapper = styled(Flex)`
  position: relative;
  width: fit-content;
  cursor: pointer;
  user-select: none;
  -webkit-user-select: none;

  &:hover {
    ${RecommendedPayContainer} {
      border-color: ${({ theme: { palette } }) => palette.primary};
    }
  }
`

export const MarketRateGrid = styled.div`
  padding: ${({ theme: { mp } }) => mp.sm};
  background: ${({ theme: { palette } }) => palette.white};
  border-radius: 4px;
  border: 1px solid ${({ theme: { palette } }) => palette.border};
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: repeat(2, auto);
  row-gap: ${({ theme: { mp } }) => mp.sm};
  column-gap: ${({ theme: { mp } }) => mp.sm};
  align-items: center;

  > *:nth-child(2),
  > *:nth-child(4) {
    justify-self: end;
  }
`

export const NoneUserSelectText = styled(Text)`
  user-select: none;
  -webkit-user-select: none;
`
